<template>
    <div class="topic_inner">
        <div class="topic_item" v-for="i in 6" :key="i">
            <Skeletor width="100%" height="88"/>
        </div>
    </div>
</template>